var map = {
	"./alipay.svg": 62244,
	"./amex.svg": 77123,
	"./code.svg": 1869,
	"./diners.svg": 80997,
	"./discover.svg": 7423,
	"./elo.svg": 82108,
	"./generic.svg": 61257,
	"./hiper.svg": 11492,
	"./hipercard.svg": 34550,
	"./jcb.svg": 31331,
	"./maestro.svg": 72045,
	"./mastercard.svg": 35754,
	"./mir.svg": 7062,
	"./paypal.svg": 93211,
	"./unionpay.svg": 28727,
	"./visa.svg": 81709
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20079;